import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLoaderData } from 'react-router-dom';
import { analytics, events } from 'services/analytics';
import { actions, fetchSong } from 'services/store/remixer';
import { AppDispatch } from 'services/store';
import {
  checkCurrentSongError,
  selectInitialSong,
} from 'services/store/remixer/selectors';
import Remixer from './Remixer';

const RemixerSongContainer = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id, isAIGenerated } = useLoaderData() as {
    id: string;
    isAIGenerated: boolean;
  };

  const remixerError = useSelector(checkCurrentSongError);

  useEffect(() => {
    if (!id) {
      return;
    }
    dispatch(fetchSong({ id, isAIGenerated }));
  }, [id, isAIGenerated, dispatch]);

  const initialSong = useSelector(selectInitialSong);

  useEffect(() => {
    const shouldClearState = id && id !== initialSong?.data?.id;
    if (shouldClearState) {
      dispatch(actions.clearState());
    }
  }, [initialSong, id, dispatch]);

  useEffect(() => {
    if (remixerError) {
      analytics.track(events.studioError(remixerError));
    }
  }, [remixerError]);

  return <Remixer />;
};

export default RemixerSongContainer;
